import { type ApplicationServerStateType } from 'src/state';
import {
  isConsentServerState,
  isErrorServerState,
  isLoginServerState,
  isSelectAccountServerState,
  type LoginServerState,
} from 'src/state/server';

// Initial server state
export const initialServerState: ApplicationServerStateType =
  {} as LoginServerState;

export interface IInitialStateService {
  getInitialState(): ApplicationServerStateType;
  getTypeName(): string;
  isValidInitialState(): boolean;
}

type InitialStateTypeName =
  | 'LoginServerState'
  | 'SelectAccountServerState'
  | 'ConsentServerState'
  | 'ErrorServerState'
  | 'UnknownServerState';

export class InitialStateService implements IInitialStateService {
  private readonly initialState: ApplicationServerStateType;

  constructor() {
    this.initialState = window.__INITIAL_SERVER_STATE__ || initialServerState;
  }

  getInitialState(): ApplicationServerStateType {
    return this.initialState;
  }

  getTypeName(): InitialStateTypeName {
    if (isLoginServerState(this.initialState)) {
      return 'LoginServerState';
    } else if (isSelectAccountServerState(this.initialState)) {
      return 'SelectAccountServerState';
    } else if (isConsentServerState(this.initialState)) {
      return 'ConsentServerState';
    } else if (isErrorServerState(this.initialState)) {
      return 'ErrorServerState';
    } else {
      return 'UnknownServerState';
    }
  }

  isValidInitialState(): boolean {
    return this.getTypeName() !== 'UnknownServerState';
  }
}
export const InitialStateServiceToken = Symbol(InitialStateService.name);
